import type { SCFormFieldProps } from './form_field';
import { FormColor } from 'eone-ui/forms/form-color';
import { handleFieldUp } from './helper';
import { SCFormField } from './form_field';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import './styles.css';

interface SCFormFieldColourProps extends SCFormFieldProps {
  AutoFocus?: boolean;
  Icon?: IconProp;
  Password?: boolean;
}

const SCFormFieldColour = ({
  label,
  name,
  required,
  disabled,
  rules,
  ...rest
}: SCFormFieldColourProps) => {
  return (
    <SCFormField label={label} name={name} disabled={disabled} required={required} rules={rules}>
      {({ field, extraProps }) => {
        return (
          <FormColor
            {...handleFieldUp(field, { disabledRef: true })}
            Label={label}
            Required={required}
            // ShowRequiredIndicator={required}
            {...rest}
            {...extraProps}
          />
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldColour };
export type { SCFormFieldColourProps };
